import * as React from 'react';
import classNames from 'classnames';
import ControlToggle from '../ControlToggle';
import './styles.scss';

export interface IControlToggleWithLabelProps {
  /** Label to display */
  label: string | React.ReactNode;
  /** State of toggle */
  checked: boolean;
  /** Change event */
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** Disabled status */
  disabled?: boolean;
  /** Reversed layout */
  reversed?: boolean;
}

/**
 * ControlToggle extension to display label with toggle element.
 */
const ControlToggleWithLabel: React.FunctionComponent<IControlToggleWithLabelProps> = (props) => {
  return (
    <div className={classNames('control-toggle-with-label', { ['reversed']: props.reversed })}>
      <ControlToggle
        disabled={props.disabled ? true : undefined}
        checked={props.checked}
        onChange={props.onChange}
      />
      <div className={'control-toggle-with-label__label__wrapper'}>
        <span className={'control-toggle-with-label__label'}>{props.label}</span>
      </div>
    </div>
  );
};

ControlToggleWithLabel.displayName = 'ControlToggleWithLabel';

export default ControlToggleWithLabel;
